// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animations_animation__nMHTf {
  transition: all 0.3s linear;
}
.animations_animation__nMHTf.animations_opacity__Z1oIL {
  opacity: 0;
  visibility: hidden;
}
.animations_animation__nMHTf.animations_opacity__Z1oIL.animations_active__S5Jn0 {
  opacity: 1;
  visibility: visible;
}
.animations_animation__nMHTf.animations_slide-bottom__\\+xvcf {
  transform: translateY(20px);
  visibility: hidden;
  opacity: 0;
}
.animations_animation__nMHTf.animations_slide-bottom__\\+xvcf.animations_active__S5Jn0 {
  transform: translateY(0);
  visibility: visible;
  opacity: 1;
}
.animations_animation__nMHTf.animations_slide-top__7C5ns {
  transform: translateY(-20px);
  visibility: hidden;
  opacity: 0;
}
.animations_animation__nMHTf.animations_slide-top__7C5ns.animations_active__S5Jn0 {
  transform: translateY(0);
  visibility: visible;
  opacity: 1;
}
.animations_animation__nMHTf.animations_slide-left__mYZXb {
  transform: translateX(-20px);
  visibility: hidden;
  opacity: 0;
}
.animations_animation__nMHTf.animations_slide-left__mYZXb.animations_active__S5Jn0 {
  transform: translateX(0);
  visibility: visible;
  opacity: 1;
}
.animations_animation__nMHTf.animations_slide-right__6rzkj {
  transform: translateX(20px);
  visibility: hidden;
  opacity: 0;
}
.animations_animation__nMHTf.animations_slide-right__6rzkj.animations_active__S5Jn0 {
  transform: translateX(0);
  visibility: visible;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/Animations/animations.module.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;AACE;EACE,UAAA;EACA,kBAAA;AACJ;AACI;EACE,UAAA;EACA,mBAAA;AACN;AAGE;EACE,2BAAA;EACA,kBAAA;EACA,UAAA;AADJ;AAGI;EACE,wBAAA;EACA,mBAAA;EACA,UAAA;AADN;AAKE;EACE,4BAAA;EACA,kBAAA;EACA,UAAA;AAHJ;AAKI;EACE,wBAAA;EACA,mBAAA;EACA,UAAA;AAHN;AAOE;EACE,4BAAA;EACA,kBAAA;EACA,UAAA;AALJ;AAOI;EACE,wBAAA;EACA,mBAAA;EACA,UAAA;AALN;AASE;EACE,2BAAA;EACA,kBAAA;EACA,UAAA;AAPJ;AASI;EACE,wBAAA;EACA,mBAAA;EACA,UAAA;AAPN","sourcesContent":[".animation {\n  transition: all 0.3s linear;\n\n  &.opacity {\n    opacity: 0;\n    visibility: hidden;\n\n    &.active {\n      opacity: 1;\n      visibility: visible;\n    }\n  }\n\n  &.slide-bottom {\n    transform: translateY(20px);\n    visibility: hidden;\n    opacity: 0;\n\n    &.active {\n      transform: translateY(0);\n      visibility: visible;\n      opacity: 1;\n    }\n  }\n\n  &.slide-top {\n    transform: translateY(-20px);\n    visibility: hidden;\n    opacity: 0;\n\n    &.active {\n      transform: translateY(0);\n      visibility: visible;\n      opacity: 1;\n    }\n  }\n\n  &.slide-left {\n    transform: translateX(-20px);\n    visibility: hidden;\n    opacity: 0;\n\n    &.active {\n      transform: translateX(0);\n      visibility: visible;\n      opacity: 1;\n    }\n  }\n\n  &.slide-right {\n    transform: translateX(20px);\n    visibility: hidden;\n    opacity: 0;\n\n    &.active {\n      transform: translateX(0);\n      visibility: visible;\n      opacity: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"animation": `animations_animation__nMHTf`,
	"opacity": `animations_opacity__Z1oIL`,
	"active": `animations_active__S5Jn0`,
	"slide-bottom": `animations_slide-bottom__+xvcf`,
	"slide-top": `animations_slide-top__7C5ns`,
	"slide-left": `animations_slide-left__mYZXb`,
	"slide-right": `animations_slide-right__6rzkj`
};
export default ___CSS_LOADER_EXPORT___;
